import { render, staticRenderFns } from "./Integrated.vue?vue&type=template&id=a310b560&"
import script from "./Integrated.vue?vue&type=script&lang=js&"
export * from "./Integrated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports